import { FC, useState } from 'react'
import { ClockIcon, FileTextIcon, ShoppingCartIcon, VideotapeIcon } from 'lucide-react'
import { ShareDialog } from '../../..'
import { useAppSelector } from '../../../../redux'
import {
  formatMultipleString,
  formatVideoLength,
  getCourseLessonCount,
  getCoursePrice,
  getCourseResourceCount,
  getCourseVideoLength,
  useCourse
} from '../../../../utils'
import { CoursePreviewVideo } from '..'
import { StyledCoursePreviewCard } from '.'

const CoursePreviewCard: FC = () => {
  const [showShare, setShowShare] = useState(false)
  const { user } = useAppSelector((state) => state.user)
  const { course, loading } = useAppSelector((state) => state.course)
  const { checkout } = useCourse()

  return (
    <>
      <StyledCoursePreviewCard>
        <div />
        <div className="card">
          <CoursePreviewVideo />
          <div className="course-details">
            <div className="course-payment-info">
              <div className="course-price">
                <span className="course-price-value">${getCoursePrice(course, user)}</span>
                <span className="course-price-currency">USD</span>
              </div>
              {course?.hasPaymentPlans && (
                <span className="course-payment-plan">Payment plans available</span>
              )}
            </div>
            <ul className="course-bullets">
              <li>
                <VideotapeIcon /> {formatMultipleString('lesson', getCourseLessonCount(course))} (
                {formatVideoLength(getCourseVideoLength(course))})
              </li>
              <li>
                <FileTextIcon />{' '}
                {formatMultipleString('downloadable resource', getCourseResourceCount(course))}
              </li>
              <li>
                <ClockIcon /> Online and at your own pace
              </li>
            </ul>
            <div className="course-actions">
              <button className="buy-btn" disabled={loading} onClick={() => checkout()}>
                <ShoppingCartIcon />
                Buy this course
              </button>
              <button className="share-btn" onClick={() => setShowShare(true)}>
                Share
              </button>
            </div>
          </div>
        </div>
      </StyledCoursePreviewCard>
      {showShare && <ShareDialog onClose={() => setShowShare(false)} />}
    </>
  )
}

export default CoursePreviewCard
